import { TimeInput as MTTimeInput, TimeInputProps } from '@mantine/dates';
import { IconClock } from '@tabler/icons-react';
import styles from './styles.module.css';

export const TimeInput = (props: TimeInputProps) => {
	return <MTTimeInput label="Time" {...props} leftSection={<IconClock />} classNames={styles} />;
};
